// Utility function to convert PascalCase or camelCase to human-readable string
export function pascalToHuman(str: string): string {
  if (!str) return '';

  const spaced = str
    // Insert space between acronym (all caps) and a following Capitalized word
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    // Insert space between lower/number and Upper boundaries
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2');

  const normalized = spaced.replace(/\s+/g, ' ').trim();

  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function camelCaseToHuman(str: string): string {
  if (!str) return '';

  // Normalize kebab/snake to spaces
  let s = str.replace(/[-_]+/g, ' ');

  // If starts with a single lowercase followed by 2+ capitals, merge into acronym (e.g., aBC... -> ABC...)
  s = s.replace(
    /^([a-z])([A-Z]{2,})/,
    (_: string, a: string, caps: string): string => a.toUpperCase() + caps
  );

  // Space between acronym and following Capitalized word (e.g., ABCValue -> ABC Value)
  s = s.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');

  // Space between lower/number and Upper boundaries (e.g., valueID -> value ID)
  s = s.replace(/([a-z0-9])([A-Z])/g, '$1 $2');

  const normalized = s.replace(/\s+/g, ' ').trim();

  return normalized ? normalized.charAt(0).toUpperCase() + normalized.slice(1) : '';
}

// Normalize a path string by removing a trailing slash (except for root '/')
export function normalizePath(p: string): string {
  if (!p) return '';
  if (p === '/') return '/';
  return p.endsWith('/') ? p.slice(0, -1) : p;
}

export function getInitials(name: string): string {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}